import React from "react"
import { Button, Spinner } from "reactstrap"

const ButtonLoader = ({ children, loading, disabled, loadingText = "Salvando...", ...props }) => {
    return (
        <Button disabled={disabled || loading} {...props}>
            {loading ? (
                <>
                    <Spinner size="sm" className="me-2" />
                    {loadingText}
                </>
            ) : (
                children
            )}
        </Button>
    )
}

export default ButtonLoader
